import { render, staticRenderFns } from "./IconEmbed.vue?vue&type=template&id=2221af03&"
import script from "./IconEmbed.vue?vue&type=script&lang=js&"
export * from "./IconEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2221af03')) {
      api.createRecord('2221af03', component.options)
    } else {
      api.reload('2221af03', component.options)
    }
    module.hot.accept("./IconEmbed.vue?vue&type=template&id=2221af03&", function () {
      api.rerender('2221af03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconEmbed.vue"
export default component.exports